import LegacyUnitCollectionView from 'scripts/defa/legacy/view-legacy-unit-collection-view';
import ActiveContainer          from 'scripts/poppet/active-container';
import template                 from 'templates/legacyUnitContainer.jst.html';

/**
 * defa.views.LegacyUnitContainer
 * A container for your legacy unit collection view.
 * @version 1.2.0
 */

const selectors = {
	container: '[data-region=units-container]',
};

const LegacyUnitContainer = ActiveContainer.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.container,
	},
	
	templateContext: function () {
		return {
			first: this.options.first,
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to open.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewOpen: function ( childView ) {
		this.trigger( 'legacyUnit:open', childView.model.get( 'unitId' ) );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches the CollectionView to the DOM.
	 * @void
	 */
	attachView: function () {
		let legacyUnitCollectionView = new LegacyUnitCollectionView( {
			collection: this.model.get( 'units' ),
		} );
		
		this.showChildView( 'container', legacyUnitCollectionView );
	},
	
} );

export default LegacyUnitContainer;